import {
  ModalContent,
  ModalRoot,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.js';
import { FC, ReactNode, useState } from 'react';
import { StreamPostInput } from '@/__generated__/graphql.ts';
import { NewPostForm } from '../new-post-modal/form.tsx';
import { useAddStreamPost } from './use-add-stream-post.ts';

export type NewStreamPostModalProps = {
  trigger: ReactNode;
  streamId: string;
  label?: string;
};

export const NewStreamPostModal: FC<NewStreamPostModalProps> = ({
  trigger,
  streamId,
}) => {
  const [open, onOpenChange] = useState(false);
  const [addStreamPost] = useAddStreamPost();

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalTrigger asChild>{trigger}</ModalTrigger>
      <ModalContent>
        <NewPostForm<StreamPostInput>
          onSubmit={async ({ text, media, customTarget, metadata }) => {
            await addStreamPost({
              streamId,
              text,
              media,
              customTarget,
              metadata,
            });
            onOpenChange(false);
          }}
          withReputationBet={false}
        />
      </ModalContent>
    </ModalRoot>
  );
};
